const useQuery = (key: string): string | undefined => new URLSearchParams(window.location.search).get(key) || undefined;

export default useQuery;
